import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Customization } from './model/customization.model';
import { ErrorCode } from '../../models/error-code.model';

export const CustomizationApiActions = createActionGroup({
    source: 'API/Customization',
    events: {
        'load customization': emptyProps()
    }
});

export const CustomizationActions = createActionGroup({
    source: 'Customization',
    events: {
        'load customization success': props<{ customization: Customization }>(),
        'load customization failure': props<{ error: ErrorCode }>(),
        'set customization': props<{ customization: Customization }>()
    }
});
